exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#product-select-dropdown button.dropdown-toggle{display:none}.scrollable-dropdown .dropdown-menu{max-height:200px;overflow-y:auto}", ""]);

// exports
